import Resource from '@/api/resources/Resource'

class PortionRevisionServices extends Resource {
    async getAllPortionRevisions(caseId, sampleId, portionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/revisions`)
        return response.data
    }

    async getPortionRevision(caseId, sampleId, portionId, revisionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/revisions/${revisionId}`)
        return response.data
    }

    async getPortionUnfinishedRevision(caseId, sampleId, portionId, laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/revisions/unfinished`)
        return response.data
    }
}

export default new PortionRevisionServices()
